import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum DocumentNumberingResetId {
  YEAR_END = 'year-end',
  MONTH_END = 'month-end',
  NEVER = 'never',
}

export class DocumentNumberingReset extends Codebook<DocumentNumberingResetId> {
  private constructor(
    public readonly value: DocumentNumberingResetId,
    public readonly label: () => string,
  ) {
    super(value)
  }

  static readonly YEAR_END = new DocumentNumberingReset(DocumentNumberingResetId.YEAR_END, () =>
    $t('End of the year'),
  )
  static readonly MONTH_END = new DocumentNumberingReset(DocumentNumberingResetId.MONTH_END, () =>
    $t('End of the month'),
  )
  static readonly NEVER = new DocumentNumberingReset(DocumentNumberingResetId.NEVER, () =>
    $t('Never'),
  )
}
